export default {"src":"/_next/static/media/dog-plus.fa6d788e.svg","height":264,"width":273};